import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, Award, Star, Clock, Users } from 'lucide-react';
import { getCheckoutUrlWithUtms } from '@/lib/checkout';
const ProfessionalProductSection = () => {
  const courseFeatures = ["12 módulos completos + 14 aulas bônus exclusivas", "Certificado profissional reconhecido", "Método PPS aplicado em casos reais", "Técnicas avançadas para consultorias", "Base científica sólida e atualizada", "Acesso vitalício ao conteúdo", "Suporte técnico especializado", "Material complementar para download", "Atualizações gratuitas do conteúdo"];
  const bonusContent = ["14 Aulas Bônus Especializadas", "Material de Apoio Profissional", "Templates para Consultorias", "Protocolos de Atendimento", "Casos Clínicos Documentados"];
  return <section id="cta" data-section="cta" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Sua Profissionalização Começa Aqui
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A formação mais completa em aleitamento materno para profissionais que 
            querem se destacar no mercado
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Urgency Badge */}
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 z-20 whitespace-nowrap bg-amber-400 text-gray-900 px-6 py-2 rounded-full font-bold text-sm md:text-base shadow-lg">
              Vagas limitadas para esta turma
            </div>
            
            <Card className="border-2 border-accent shadow-2xl bg-white">
              <CardHeader className="text-center pb-4 bg-primary/5">
                <div className="mb-4 mt-6">
                  <h3 className="text-2xl font-bold text-primary mb-2">
                    Amamentação de Ouro
                  </h3>
                </div>
                
                <CardTitle className="text-2xl font-bold text-gray-900 mb-3">
                  Aperfeiçoamento Completo em Aleitamento Materno
                </CardTitle>
                
                <p className="text-gray-600 text-lg">
                  Para profissionais que querem se tornar referência em amamentação
                </p>
                
                <div className="mt-6">
                  <span className="text-4xl font-bold text-gray-900">
                    R$ 497,00
                  </span>
                  <p className="text-sm text-gray-600 mt-1">
                    ou 12x de R$ 51,40 no cartão
                  </p>
                </div>
              </CardHeader>

              <CardContent className="pt-6">
                {/* Professional Benefits */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                  <div className="border-t border-gray-100 pt-4">
                    <div className="flex items-center gap-3 mb-2">
                      <Award className="h-5 w-5 text-primary" />
                      <span className="font-semibold text-gray-900">Certificação</span>
                    </div>
                    <p className="text-sm text-gray-600">Certificado de aperfeiçoamento profissional — emitido pela Rosane Baldissera, Consultora de Lactação certificada pelo IBLCE</p>
                  </div>
                  
                  <div className="border-t border-gray-100 pt-4">
                    <div className="flex items-center gap-3 mb-2">
                      <Users className="h-5 w-5 text-accent-ink" />
                      <span className="font-semibold text-gray-900">Casos Reais</span>
                    </div>
                    <p className="text-sm text-gray-600">Demonstrações com mães reais</p>
                  </div>
                  
                  <div className="border-t border-gray-100 pt-4">
                    <div className="flex items-center gap-3 mb-2">
                      <Clock className="h-5 w-5 text-secondary-dark" />
                      <span className="font-semibold text-gray-900">25+ Horas</span>
                    </div>
                    <p className="text-sm text-gray-600">Conteúdo técnico especializado</p>
                  </div>
                  
                  <div className="border-t border-gray-100 pt-4">
                    <div className="flex items-center gap-3 mb-2">
                      <Star className="h-5 w-5 text-green-700" />
                      <span className="font-semibold text-gray-900">Acesso Vitalício</span>
                    </div>
                    <p className="text-sm text-gray-600">Aprenda no seu ritmo profissional</p>
                  </div>
                </div>

                {/* Course Features */}
                <div className="mb-8">
                  <h4 className="text-lg font-bold text-gray-900 mb-4 text-center">
                    O Que Você Vai Receber:
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {courseFeatures.map((feature, index) => <div key={index} className="flex items-start gap-3">
                        <CheckCircle className="h-5 w-5 text-green-700 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 text-sm">
                          {feature}
                        </span>
                      </div>)}
                  </div>
                </div>


                {/* CTA Button */}
                <Button 
                  className="w-full bg-accent-ink hover:bg-accent-ink-dark text-white font-bold py-4 rounded-xl text-base md:text-lg shadow-lg transition-[background-color,transform] duration-200 ease-out active:scale-[0.97]" 
                  onClick={() => window.location.href = getCheckoutUrlWithUtms('https://pay.hotmart.com/T84177472Y?off=s3ddbg8f&checkoutMode=10')}
                >
                  <span className="block md:inline">Garantir Curso</span>
                </Button>

                {/* Guarantee */}
                <div className="mt-6 text-center">
                  <p className="text-sm text-gray-600">
                    <strong>Garantia de 7 dias</strong> · <strong>Certificado Profissional Incluso</strong>
                    <br />
                    <strong>Acesso Vitalício</strong> · <strong>Suporte Técnico Especializado</strong>
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

      </div>
    </section>;
};
export default ProfessionalProductSection;